import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { Home } from "lucide-react";

export default function PaymentCancel() {
  const navigate = useNavigate();
  return (
    <div className="app-shell dotted-bg flex items-center justify-center p-6">
      <motion.div
        initial={{ scale: 0.85, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: "spring", stiffness: 220, damping: 18 }}
        className="bg-white rounded-[2.5rem] border-4 border-slate-900/10 p-10 w-full max-w-sm text-center"
        style={{ boxShadow: "0 14px 0 0 rgba(148,163,184,0.5)" }}
        data-testid="payment-cancel-page"
      >
        <div className="text-6xl mb-3">👋</div>
        <h1 className="font-fredoka text-3xl font-bold text-slate-900">Maybe later!</h1>
        <p className="text-lg font-bold text-slate-400 mt-2 mb-8">
          No worries — nothing was charged.
        </p>
        <button
          data-testid="cancel-home-button"
          onClick={() => navigate("/home")}
          className="toy-btn w-full flex items-center justify-center gap-2 bg-blue-500 text-white font-fredoka text-2xl font-bold py-4 rounded-2xl"
          style={{ boxShadow: "0 6px 0 0 rgba(37,99,235,1)" }}
        >
          <Home size={26} strokeWidth={3} /> Back Home
        </button>
      </motion.div>
    </div>
  );
}
